export default __webpack_public_path__ + "static/media/ci.47413a87.png";